export default "__VITE_ASSET__C6Uo7wxb__"